import script from "./imageStripe.vue?vue&type=script&setup=true&lang=js"
export * from "./imageStripe.vue?vue&type=script&setup=true&lang=js"

import "./imageStripe.vue?vue&type=style&index=0&id=7a4a8fbf&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a4a8fbf"]])

export default __exports__